module.exports = __webpack_public_path__ + "img/2_1-commerciale-cinema-0.217f0a5c.png";